import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthStorageService } from '../services/auth-storage.service';

export const roleGuard =
  (allowedRoles: string[]): CanActivateFn => {

    return async () => {

      const platformId = inject(PLATFORM_ID);
      if (!isPlatformBrowser(platformId)) {
        return false;
      }

      const authService = inject(AuthService);
      const authStorage = inject(AuthStorageService);
      const router = inject(Router);

      await authService.bootstrap();

      const user = authStorage.currentUser();

      if (!user || !allowedRoles.includes(user.role)
      ) {

        return router.createUrlTree([
          user ? (user.role === 'TRADER' ? '/trader/dashboard' : '/client/dashboard') : '/auth/login'
        ]);

      }

      return true;

    };

  };
